const render = icon => {
  //<i aria-hidden="true" class="v-icon notranslate fa fa-question-circle theme--light primary--text" style=""></i>
  return `<i aria-hidden="true" class="v-icon notranslate ${icon}"></i>`
}

const icon = md => {
  let lines = md.match(/[^\r\n]+/g)

  if (lines === null || lines.length <= 0) {
    return md
  }

  const key = "@[icon]("

  for (let i in lines) {
    const line = lines[i]

    if (!line.startsWith(key) || !line.endsWith(")")) {
      continue
    }

    let icon = line.slice(key.length, line.length - 1)
    let classNumber = (icon.match(/ /g) || []).length
    if (classNumber === 1) {
      icon = icon + " tw-float-left tw-m-5 tw-text-blue-400"
    }

    lines[i] = render(icon)
  }

  return lines.join("\n\r")
}

export { icon }
